const globalLang = {
  subscribeLegal: {
    en: 'I consent to receive email and other electronic communications with information, promotions and offers about products and services from Mazda Canada Inc.(<a href="/en/contact-us/" className="mz-link">CONTACT US</a>) and its <a href="/en/shopping/find-a-retailer/" className="mz-link">DEALERS</a> that are relevant to my interests based on information Mazda has about me. Consent is sought by Mazda for itself and its dealers. I may unsubscribe at any time. I also consent for Mazda to use my information in accordance with its <a href="/en/privacy/" className="mz-link">PRIVACY POLICY</a>.',
    fr: 'Je consens à recevoir des courriels et autres communications électroniques contenant de l’information, des promotions et des offres sur les produits et services de Mazda Canada inc. (<a href="/fr/Nous-joindre/" className="mz-link">CONTACTEZ-NOUS</a>) et de ses <a href="/fr/magasiner/Trouver-un-concessionnaire/" className="mz-link">CONCESSIONNAIRES</a>, qui correspondent à mes intérêts en fonction des données que Mazda possède à mon sujet. Mon consentement est demandé par Mazda pour elle-même et ses concessionnaires. Je pourrai me désabonner à tout moment. Je consens également à ce que Mazda utilise mes renseignements personnels conformément à sa <a href="/fr/confidentialite/" className="mz-link">POLITIQUE DE CONFIDENTIALITÉ</a>.'
  },
  emailEncouragement: {
    en: 'Keep up to date on the latest Mazda news from Canada and around the world. Receive our monthly newsletter, be the first to hear about new technology, innovations, new vehicles releases, and a whole lot more.',
    fr: 'Restez informé des dernières nouvelles concernant Mazda au Canada et dans le monde entier. Recevez notre infolettre mensuelle et soyez parmi les premiers à découvrir des nouvelles technologies, des innovations, des nouveaux véhicules et bien d\'autres choses encore.',
  },
  or: {
    en: 'or',
    fr: 'ou'
  },
  to: {
    en: 'to',
    fr: 'à'
  },
  percent_symbol: {
    en: '%',
    fr: ' %'
  },
  hours: {
    en: 'hours',
    fr: 'heures'
  },
  adds: {
    en: 'adds',
    fr: 'ajoute'
  },
  findDealerSub: {
    en: ' FIND YOUR PREFFERED RETAILER  ',
    fr: 'TROUVEZ VOTRE DÉTAILLANT PRÉFÉRÉ '
  },
  selectVehicle: {
    en: 'Select your vehicle',
    fr: 'CHOISISSEZ VOTRE VÉHICULE'
  },
  selectDealer: {
    en: 'Select this retailer',
    fr: 'Choisir ce détaillant'
  },
  scheduleService: {
    en: 'Schedule a service',
    fr: 'schedule service fr'
  },
  selectDateAndTime: {
    en: 'SELECT YOUR PREFERRED DATE AND TIME OF DAY ',
    fr: 'CHOISISSEZ VOS DATE ET HEURE PRÉFÉRÉES'
  },
  fillContactForm: {
    en: 'Please fill out your contact details',
    fr: 'VEUILLEZ INSCRIRE VOS COORDONNÉES'
  },
  unavailableInRegion: {
    en: 'Unavailable in your region',
    fr: 'Unavailable in your region (FR)'
  },
  previous: {
    en: 'Previous models',
    fr: 'MODÈLES PRÉCÉDENTS',
  },
  morning: {
    en: 'morning',
    fr: 'matin',
  },
  afternoon: {
    en: 'afternoon',
    fr: 'après-midi',
  },
  evening: {
    en: 'evening',
    fr: 'soir',
  },
  continue: {
    en: 'continue',
    fr: 'CONTINUER ',
  },
  requiredFields: {
    en: 'Required Fields',
    fr: 'Champs obligatoires',
  },
  date: {
    en: 'Preferred Date:',
    fr: 'Date préférée :',
  },
  timePreference: {
    en: 'Time of Day:',
    fr: 'Heure préférée :',
  },
  dealerWebsite: {
    en: 'Visit Website',
    fr: 'Visiter le site web',
  },
  dealerDirections: {
    en: 'Get Directions',
    fr: 'Obtenir un itinéraire',
  },
  drag360: {
    en: 'Drag to view',
    fr: 'Faire pivoter',
  },
  selectDealerNav: {
    en: 'Select a retailer',
    fr: 'TROUVER UN DÉTAILLANT',
  },
  selectDateAndTimeNav: {
    en: 'Select Date & time',
    fr: 'CHOISIR LA DATE ET L\'HEURE',
  },
  contactDetailsNav: {
    en: 'Contact details',
    fr: 'COORDONNÉES',
  },
  step: {
    en: 'STEP',
    fr: 'ÉTAPE',
  },
  vehicles: {
    en: 'Vehicles',
    fr: 'VÉHICULES',
  },
  change: {
    en: 'Change',
    fr: 'modifier',
  },
  noResults: {
    en: 'Not found. Is the spelling correct?',
    fr: 'Pas trouvé. Le nom est-il entré correctement ? '
  },
  httpResponseError: {
    en: 'Error: Request failed with status code',
    fr: 'Erreur : La demande a échoué avec ce code '
  },
  learnMore: {
    en: 'Learn More',
    fr: 'EN SAVOIR PLUS ',
  },
  asOf: {
    en: 'As of',
    fr: 'Depuis le ',
  },
  buildAndPrice: {
    en: 'Build and price',
    fr: 'CONSTRUCTION ET PRIX ',
  },
  odometer: {
    en: 'Odometer',
    fr: 'Odomètre',
  },
  vin: {
    en: 'VIN',
    fr: 'NIV',
  },
  popular: {
    en: 'Popular',
    fr: 'Populaire',
  },
  pricePrefix: {
	en: 'Starting at ',
	fr: 'À partir de ',
  },
  backToSummary: {
    en: 'Back to summary',
    fr: 'Retour au récapitulatif',
  }
}

export default globalLang;